import { useDrop } from 'react-dnd';

import { DRAGGABLE_ITEM_TYPES } from 'features/planning/config';

type CoachingToolDroppableProps<T> = {
  onDrop?: (item: T) => void;
  children?: React.ReactNode;
  onHover?: (item: T) => void;
  height?: string;
  width?: string;
  sprintId: string;
};

export const CoachingToolDroppable = <T,>({
  children,
  onDrop,
  onHover,
  sprintId,
  height = '100%',
  width = '100%',
}: CoachingToolDroppableProps<T>) => {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: [DRAGGABLE_ITEM_TYPES.COACHING_TOOL],
      drop(item: T, monitor) {
        if (monitor.isOver()) {
          onDrop?.(item);
        }
      },
      hover(item: T, monitor) {
        if (monitor.isOver()) {
          onHover?.(item);
        }
      },
      collect: (monitor: any) => {
        const item = monitor.getItem();

        return {
          isOver: item && item.fromSprintId !== sprintId && monitor.isOver(),
        };
      },
    }),
    [onDrop]
  );

  return (
    <div
      ref={drop}
      style={{
        height,
        width,
        borderRadius: '1rem',
        border: `1px solid ${isOver ? 'var(--brdAccent)' : 'transparent'}`,
      }}
    >
      {children}
    </div>
  );
};
